<ng-container *ngIf="email">
  <div class="header">
    <div class="title">
      {{ email.data?.subject }}
    </div>

    <div class="email-actions">
      <button class="open-email-button" *ngIf="email.data?.web_link" mat-button (click)="openEmail()" [tabIndex]="-1">
        Open In Office Online
      </button>
      <button class="delete-button" mat-icon-button (click)="onDeleteEmail(email)" [tabIndex]="-1">
        <mat-icon [svgIcon]="'delete'"></mat-icon>
      </button>
      <button class="close-button" mat-icon-button (click)="onClose()" [tabIndex]="-1">
        <mat-icon [svgIcon]="'close'"></mat-icon>
      </button>
    </div>
  </div>

  <div class="threads">
    <div class="thread">
      <!-- Content -->
      <div class="body">
        <div class="email-from">
          <span *ngIf="email.data?.from">{{ email.data.from[0]?.name }} &lt;{{ email.data.from[0]?.email }}&gt;</span>
        </div>
        <div class="email-received-at">{{ email.received_at | date: 'EE M/d/yy h:mm a' }}</div>
        <div class="email-to" *ngIf="email.data?.to">
          To: <span class="email-to">{{ email.data.to[0]?.name }}</span>
        </div>
        <div class="email-body" [innerHTML]="email.data?.body || email.data?.body_preview | htmlSanitizer"></div>
      </div>

      <!-- Attachments -->
      <ng-container *ngIf="email.file_resources?.length">
        <div class="attachments">
          <div class="title">
            <mat-icon [svgIcon]="'attachment'"></mat-icon>
            <div>{{ email.file_resources.length }} Attachments</div>
          </div>

          <div class="files">
            <div class="file" *ngFor="let attachment of email.file_resources; trackBy: trackByFn">
              <div class="file-info">
                <div class="file-name" [title]="attachment.name" (click)="viewFile(attachment)">
                  {{ attachment.name }}
                </div>

                <div class="file-size" [title]="attachment.file_size">
                  {{ attachment.file_size / 1000 | number: '1.0-2' }} KB
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
